<mat-expansion-panel id="application-status-panel">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h1 class="card-title">Application Status</h1>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- <mat-card class="main-container">
    <mat-card-title> -->

  <div style="padding: 40px">
    <div class="actions-box">
      <mat-form-field appearance="outline" class="search-bar">
        <input
          matInput
          #search
          (keyup)="applyFilter($event)"
          maxlength="256"
          placeholder="Search"
        />
        <mat-icon matSuffix>search</mat-icon>

        <mat-hint align="start"
          >Example: Name, Application #, Seneca ID</mat-hint
        >
      </mat-form-field>

      <br />
    </div>
    <!-- </mat-card-title> -->

    <!-- <mat-card-content class="example-container mat-elevation-z8"> -->

    <mat-card class="tablet-container mat-elevation-z0">
      <div style="overflow-x: auto">
        <table mat-table [dataSource]="dataSource" matSort>
          <!--- Note that these columns can be defined in any order.
                        The actual rendered columns are set as a property on the row definition" -->

          <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <b>Last Name, First Name</b>
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label">Last Name, First Name </span>
              <span class="styled"> {{ element.fullName }} </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="applicationNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <b>Application Number</b>
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label">Application Number </span>
              <span class="styled"> {{ element.applicationNumber }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="studentNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <b>Student #</b>
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label">Student #</span>
              <span class="styled"> {{ element.studentNumber }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="term">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <b>Term</b>
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label">Term</span>
              <span class="styled"> {{ element.term }} </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="programName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <b>Program Name</b>
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label">Program Name</span>

              <span class="styled"> {{ element.programName }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="campus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <b>Campus</b>
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label">Campus</span>
              <span class="styled"> {{ element.campus }} </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="statusDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <b>Status Date</b>
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label"><b>Status Date</b></span>
              <span class="styled">
                {{ element.statusDate | date : "mediumDate" }}</span
              >
            </td>
          </ng-container>

          <ng-container matColumnDef="applicationStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <b>Application Status</b>
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label"><b>Application Status</b> </span>
              <span class="styled">
                <b>{{ element.applicationStatus }}</b>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="offerLetter">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <b>Communications</b>
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label"><b>Offer Letter</b></span>
              <button
                *ngIf="element.offerLetter === 'X'"
                type="button"
                class="letter"
                mat-button
                id="uploadButton"
                color="primary"
                (click)="openOfferLetter(element)"
              >
                <mat-icon>attach_file</mat-icon>
              </button>
            </td>
          </ng-container>

          <!-- Symbol Column -->

          <!-- <ng-container matColumnDef="id">
          <th th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
          <td td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container> -->

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </mat-card>
    <span>
      <mat-paginator
        [pageSizeOptions]="[5, 10, 20, 50, 100]"
        showFirstLastButtons
      >
      </mat-paginator>
    </span>
  </div>
  <!-- </mat-card-content> -->
  <!-- class="mobile-paginator"  class="pc-paginator"-->
  <!-- <span >
      <mat-paginator #categoryPaginator [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons> </mat-paginator>
    </span> -->
  <!-- </mat-card> -->
</mat-expansion-panel>
<div *ngIf="communicationPdfLoading" class="loading-indicator">
  <mat-spinner diameter="100" strokeWidth="15"></mat-spinner>
</div>
